/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import { BrowserCacheLocation, LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

const localBack = process.env.REACT_APP_BACK;
const localFront = process.env.REACT_APP_FRONT;

export const msalConfig = {
    auth: {
        clientId: "437e768f-e3a1-4e34-8520-b67dea30471e",
        authority: "https://login.microsoftonline.com/b7af8caf-83d8-4644-85ae-317c545223c1",
        redirectUri: localFront + "/inicio",
    },
    cache: {
        cache: BrowserCacheLocation.SessionStorage, // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                     //case LogLevel.Error:
                     //    console.error(message);
                     //    return;
                     //case LogLevel.Info:
                     //    console.info(message);
                     //    return;
                     //case LogLevel.Verbose:
                     //    console.debug(message);
                     //    return;
                     //case LogLevel.Warning:
                     //    console.warn(message);
                     //    return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    extraQueryParameters: {
        domain_hint: "espol.edu.ec"
    },
    //loginHint: "@espol.edu.ec",
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: `${localBack}/usuarios/LoginADFSJT` //e.g. https://graph.microsoft.com/v1.0/me
};
